import { VDP_SEARCH_LIST_KEY } from 'constants/marketplace';
import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const EMPTY_ARRAY = Object.freeze([]);
export const useVDPAsModal = () =>
	useSelector((state) => state.buyerVehicles.searchLists[VDP_SEARCH_LIST_KEY].openAsModal);

export const getSearchListSelector = (state, searchListKey) => state.buyerVehicles.searchLists[searchListKey];
export const useSearchList = (searchListKey) => useSelector((state) => getSearchListSelector(state, searchListKey));

export const useSearchListVehicleIds = (searchListKey) =>
	useSelector((state) => getSearchListSelector(state, searchListKey)?.vehicleIds);

export const getFeaturedFromSearchListSelector = (state, searchListKey) =>
	getSearchListSelector(state, searchListKey)?.featured;

export const useFeaturedFromSearchList = (searchListKey, campaignType) =>
	useSelector((state) => getFeaturedFromSearchListSelector(state, searchListKey, campaignType));

export const getFeaturedCampaignVehiclesListSelector = (state, searchListKey, campaignType) => {
	const featured = getSearchListSelector(state, searchListKey)?.featured?.featuredCampaigns?.find(
		(fc) => fc.campaignType === campaignType,
	);
	const vehicleIds = featured?.vehicles?.map(({ id }) => id) ?? EMPTY_ARRAY;
	const { entities } = state.buyerVehicles;
	// hidden vehicles should not be shown on campaigns
	return vehicleIds.filter((vehicleId) => entities[vehicleId] && !entities[vehicleId].hidden);
};
export const useFeaturedCampaign = (searchListKey, campaignType) => {
	const vehicleIds = useSelector(
		(state) => getFeaturedCampaignVehiclesListSelector(state, searchListKey, campaignType),
		shallowEqual,
	);

	const featuredCampaign = useSelector(
		(state) =>
			getSearchListSelector(state, searchListKey)?.featured?.featuredCampaigns?.find(
				(fc) => fc.campaignType === campaignType,
			),
		shallowEqual,
	);

	return useMemo(() => ({ ...featuredCampaign, vehicleIds }), [vehicleIds, featuredCampaign]);
};

export const useVehiclesCount = (searchListKey) =>
	useSelector((state) => getSearchListSelector(state, searchListKey)?.vehicleIds?.length);

export const useTotalCount = (searchListKey) =>
	useSelector((state) => getSearchListSelector(state, searchListKey)?.totalElements);

export const useUnifiedMarketplaceSaleType = () => useSelector((state) => state.buyerVehicles.saleType);

export const useAreAllVehiclesFollowed = (searchListKey) => {
	const vehicleIds = useSearchListVehicleIds(searchListKey);
	const entities = useSelector((state) => state.buyerVehicles.entities);
	return vehicleIds?.length ? vehicleIds.every((vehicleId) => entities[vehicleId]?.following) : null;
};

export const getListConfig = (thisSliceState, searchListKey) =>
	thisSliceState.searchLists[searchListKey]?.listConfig || {};
